import { Component, OnInit } from '@angular/core';
import { NavigationEnd, NavigationStart, Router } from '@angular/router';
import { UserService } from  '../../core/services/user.service';

@Component({
    selector   : 'fuse-footer',
    templateUrl: './footer.component.html',
    styleUrls  : ['./footer.component.scss']
})
export class FuseFooterComponent implements OnInit
{

    loggedInUser: any;

    constructor(private router: Router, private userService: UserService)
    {
    }

    ngOnInit() {
        //this.loggedInUser = this.userService.currentUser.getValue();
        
        this.userService.currentUser.subscribe((updatedCurrentUser) => { 
            this.loggedInUser = updatedCurrentUser;
        }); 
    }

    //Load landing page if logged in
    goHome() {
        if (this.loggedInUser != null) 
            this.router.navigate(['/']) //TODO: use a router guard
    }
    
}



// WEBPACK FOOTER //
// C:/Users/Marion Surgical/Desktop/Sean/marion-surgical-master/src/app/main/footer/footer.component.ts